__turbopack_context__.v({
  "placeholder": "Gallery-module__n29zga__placeholder",
  "slide": "Gallery-module__n29zga__slide",
});
